import { Reveal, Eyebrow } from "../components/Reveal";

const PATHWAYS = [
  { title: "Metabolic Reset", desc: "For insulin resistance, weight, fatty liver, triglycerides and metabolic health." },
  { title: "Women's Metabolic Health", desc: "PCOS, weight, insulin resistance, thyroid patterns and perimenopausal metabolic changes." },
  { title: "Gut–Metabolic Health", desc: "For patients where digestive symptoms coexist with metabolic concerns." },
  { title: "Comprehensive Metabolic Health", desc: "For patients with multiple interconnected concerns." },
];

export const Pathways = () => (
  <section id="pathways" className="bg-white" data-testid="pathways-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20 lg:py-32">
      <Reveal className="max-w-2xl">
        <Eyebrow>06 · Care pathways</Eyebrow>
        <h2 className="mt-6 font-serif font-medium text-forest text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
          Personalised care, built around your needs.
        </h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {PATHWAYS.map((p, i) => (
          <Reveal key={p.title} delay={0.08 * i}>
            <div
              className="group border border-line bg-ivory p-8 h-full flex flex-col hover:-translate-y-1 hover:border-gold/60 transition-[transform,border-color] duration-500"
              data-testid={`pathway-card-${i}`}
            >
              <span className="h-px w-10 bg-gold mb-6 group-hover:w-16 transition-[width] duration-500" />
              <h3 className="font-serif text-2xl text-forest leading-snug">{p.title}</h3>
              <p className="mt-4 text-sm text-inkmuted leading-relaxed flex-1">{p.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <p className="mt-10 font-mono text-[11px] tracking-[0.22em] uppercase text-gold">
          Care pathways are personalised according to clinical needs.
        </p>
      </Reveal>
    </div>
  </section>
);
